import { jsx as _jsx } from "react/jsx-runtime";

function SvgPublish() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.725 6.825C6.918 7.853 6.63 9.065 6.63 9.731a1 1 0 01-1 1c-.436 0-1.092.168-1.631.608-.505.412-.96 1.104-.996 2.282a3.217 3.217 0 00.929 2.386c.272.28.568.489.832.623.28.143.463.172.516.172h2.884v1-1a1 1 0 110 2H5.28c-.476 0-.976-.162-1.422-.389a5.232 5.232 0 01-1.36-1.01 5.216 5.216 0 01-1.494-3.842c.052-1.746.766-2.985 1.73-3.771a4.78 4.78 0 011.977-.954A7.36 7.36 0 016.152 5.59C7.286 4.146 9.12 3 11.826 3c2.69 0 4.552 1.093 5.75 2.501a7.938 7.938 0 011.664 3.357 5.128 5.128 0 012.094 1.052c.997.844 1.719 2.17 1.663 4.061-.055 1.867-.794 3.133-1.801 3.903a4.594 4.594 0 01-2.838.928h-2.72a1 1 0 110-2h2.768a2.597 2.597 0 001.575-.517c.49-.375.978-1.058 1.017-2.373.038-1.29-.43-2.03-.956-2.476a3.14 3.14 0 00-1.731-.707 1 1 0 01-.933-.896c-.08-.788-.46-2.02-1.324-3.036C15.22 5.817 13.906 5 11.826 5c-2.065 0-3.33.843-4.1 1.825zM13 13.415l1.293 1.292a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L11 13.414V21a1 1 0 102 0v-7.586z"
    }, void 0)
  }), void 0);
}

export default SvgPublish;